import type { $Fetch } from 'ofetch';
import type {
  Estorno, SolicitarEstornoCommand, EstornoDecisaoCommand, EstornoStatus,
} from '@/domain/model/Estorno';
import type { Page } from '@/domain/model/Page';
import type { EstornoGateway } from '@/application/port/out/EstornoGateway';
import type { ApiResponse, SpringPage } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const PATH = '/api/v1/commerce/estornos';

export class HttpEstornoGateway implements EstornoGateway {
  constructor(private readonly client: $Fetch) {}

  async list(p: { status?: EstornoStatus; vendaId?: string; page?: number; size?: number }): Promise<Page<Estorno>> {
    const params: Record<string, string | number> = {};
    if (p.status) params['status'] = p.status;
    if (p.vendaId) params['vendaId'] = p.vendaId;
    if (typeof p.page === 'number') params['page'] = p.page;
    if (typeof p.size === 'number') params['size'] = p.size;
    const res = await this.client<ApiResponse<SpringPage<Estorno>>>(PATH, { method: 'GET', params });
    assertApiSuccess(res);
    const d = res.data;
    return { content: d.content, number: d.number, size: d.size, totalElements: d.totalElements, totalPages: d.totalPages, first: d.first, last: d.last };
  }

  async get(id: string): Promise<Estorno> {
    const res = await this.client<ApiResponse<Estorno>>(`${PATH}/${encodeURIComponent(id)}`, { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }

  async solicitar(command: SolicitarEstornoCommand): Promise<Estorno> {
    const res = await this.client<ApiResponse<Estorno>>(PATH, { method: 'POST', body: command });
    assertApiSuccess(res);
    return res.data;
  }

  async decidir(id: string, command: EstornoDecisaoCommand): Promise<Estorno> {
    const res = await this.client<ApiResponse<Estorno>>(
      `${PATH}/${encodeURIComponent(id)}/decidir`, { method: 'POST', body: command },
    );
    assertApiSuccess(res);
    return res.data;
  }

  async processarGateway(id: string): Promise<Estorno> {
    const res = await this.client<ApiResponse<Estorno>>(
      `${PATH}/${encodeURIComponent(id)}/processar-gateway`, { method: 'POST' },
    );
    assertApiSuccess(res);
    return res.data;
  }
}
